export function spaProfileAccess(can) {
  const view = can('spa-clients:view');
  const manage = view && can('spa-clients:manage');
  return {
    view,
    manage,
    viewSensitive: view && can('spa-clinical:view'),
    manageSensitive: manage && can('spa-clinical:view') && can('spa-clinical:manage'),
  };
}

export function visibleSpaProfile(profile, canViewSensitive) {
  if (!profile || canViewSensitive) return profile;
  const visible = { ...profile };
  ['allergies', 'limitations', 'internalNotes'].forEach((field) => { delete visible[field]; });
  return visible;
}
